import { css } from '@/styled-system/css';

export const toastProviderItemStyles = css.raw({
  'position': 'relative', // This creates a proper stacking context where the latest in the list is on top
  'listStyleType': 'none',
  '& [data-c11n-component="Toast.Root"]': {
    pointerEvents: 'auto',
    // Margin is applied to the Toasts as opposed to 'gap' on the flex container
    // so that this gap is included in the animation to prevent jumpiness
    marginBlockEnd: 'layout.tight',
  },
});
